import { Box, Card, CardActions, CardContent, Chip, ListItemButton, Stack, Typography } from "@mui/material";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import styles from './RangeItem.module.css'
import { IconButton } from "components/buttons";
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { ConfirmationDialog } from "components/dialogs";
import { useState } from "react";
import { NumbersOutlined } from "@mui/icons-material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";

const RangeItem = ({id, isSelected, onSelect, onDelete, name, total, connected, start, end, disabled}) => {
  
  const [open, setOpen] = useState(false);
  const okHandler = (e) => {
    onDelete({id});
    setOpen(false);
  };

  const cancelHandler = (e) => { 
    e.stopPropagation();
    setOpen(false);
  };

  const makeItem = () => ({id, start, end, name, disabled});

  return (
    <ListItemButton
      sx={{
        pr:1, pb: 1, pl:0, pt: 0, flexGrow: 1,               
        '& :hover.MuiPaper-root':{
            backgroundColor: 'rgb(248, 248, 238) !important'
        },
        '&.Mui-selected .MuiCard-root': {
            backgroundImage: 'unset',
            backgroundColor: 'aliceblue'
        }
      }}
      className={"pagelist-item " + (disabled ? 'disabled' : '')}
      selected={isSelected}
    >
      <Card sx={{width:'100%'}} 
        onClick={() => onSelect(makeItem())}
      >
        <CardContent sx={{px:2, display: 'flex', alignItems: 'stretch', padding: '0 0 0 8px !important'}}>
          <Stack className={styles.nameWrapper} direction='row' sx={{alignItems: 'center'}}>
            <NumbersOutlined color='secondary' sx={{mr: 1, fontSize: 28}}/>
            <Box m={1}>
              <Typography className={styles.name} sx={{mr: 1}}>{name}</Typography>
              <Stack direction="row" spacing={1}>
                <Chip mr={1} icon={<FontAwesomeIcon icon={faLink} />} label={'Номеров в диапазоне: ' + (total ?? 0)} />  
                <Chip icon={<FontAwesomeIcon icon={faLink} />} label={'На связи с кабинетом: ' + (connected ?? 0)} />  
              </Stack>
            </Box>
          </Stack>         
          <Stack className={styles.infoWrapper} direction="row" alignItems="center" justifyContent="space-between">
            <Typography sx={{fontFamily: 'PT Mono', fontSize: '1rem', letterSpacing: '1px'}}>{start}-{end}</Typography> 
            <IconButton
              handler={(e) => {
                e.stopPropagation();
                if(!isSelected) onSelect(makeItem());
                setOpen(true);
              }}
              text='Удалить диапазон'  
              iconCmp={<DeleteOutlinedIcon className='delete-button'/>}
              sx={{marginRight: '8px'}}
            />
          </Stack> 
          <ConfirmationDialog 
            title='Удалить диапазон'
            text={<span>Удалить диапазон <b>{name}</b>?</span>}
            open={open}
            onOk={okHandler}
            onCancel={cancelHandler}
          />
        </CardContent>  
      </Card>
    </ListItemButton>
  );
};

export default RangeItem;